import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ConditionalLayout"] */ "/app/src/app/components/general/ConditionalLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Provider"] */ "/app/src/app/components/Provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
